import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import EstatePlanningProfileSubpageImage
  from 'Views/Page/Content/Templates/Profile/Templates/ProfileTemplate/Subpages/EstatePlanningProfileSubpage/EstatePlanningProfileSubpageImagePicker/EstatePlanningProfileSubpageImage';

const EstatePlanningProfileSubpageImagePicker = ({ resource }) => {
  return pick(resource, {
    [fr.relationships.image.name]: (<EstatePlanningProfileSubpageImage imageURL={resource.relationship(fr.relationships.image.name)?.link('related')?.url()} />),
  }, null);
};

EstatePlanningProfileSubpageImagePicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
EstatePlanningProfileSubpageImagePicker.defaultProps = {};

export default EstatePlanningProfileSubpageImagePicker;
